import * as React from 'react'

import FinancialsTable from './FinancialsTable'
import {
  FinancialsColumnDefinition,
  FinancialsRowDataType,
  FinancialsSubColumnDefinition,
  FinancialsSubRowDataType,
} from './types'

type FinancialsWidgetProps<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
> = {
  children: React.ReactNode
  header?: React.ReactNode
  tableHead?: React.ReactNode
  tableFooter?: React.ReactNode
  data: RowDataType[]
  columns: ColumnDefinition[]
  subColumns: Record<string, FinancialsSubColumnDefinition<SubColumnDefinition>[]>
  onVisibilityChange: (area: string, visibility: boolean) => void
}

export function FinancialsWidget<
  RowDataType extends FinancialsRowDataType,
  ColumnDefinition extends FinancialsColumnDefinition<RowDataType>,
  SubColumnDefinition extends FinancialsSubRowDataType,
>({
  children,
  tableHead,
  tableFooter,
  columns,
  subColumns,
  header,
  data,
  onVisibilityChange,
}: FinancialsWidgetProps<RowDataType, ColumnDefinition, SubColumnDefinition>) {
  return (
    <div className="js-financials-widget">
      <div className="mb-0.5 space-y-1.5">
        {header}
        {children}
      </div>
      <FinancialsTable
        tableHead={tableHead}
        tableFooter={tableFooter}
        data={data}
        columns={columns}
        subColumns={subColumns}
        onVisibilityChange={onVisibilityChange}
      />
    </div>
  )
}
